import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const APPLICATIONS_REQUEST = 'FETCH_APPLICATIONS_REQUEST';
export const APPLICATIONS_FAILURE = 'FETCH_APPLICATIONS_FAILURE';
export const APPLICATIONS_SUCCESS = 'FETCH_APPLICATIONS_SUCCESS';

/**
 * @param {Object} [query] optional server-side filter params, e.g.
 *   `{ sex: 'female', search: 'foo' }`. For a GET, apiRequestOptions maps
 *   `data` → axios `params` → `?sex=female&search=foo`. Empty/absent ⇒ a
 *   plain `/api/applications` request (no query string) so the unfiltered
 *   fetch stays canonical and the store remains the single source of truth.
 *
 *   `{ competition: '<uuid>' }` narrows the read to ONE competition — 2.0 MB
 *   of applications against 13 KB, measured on live data — and the store then
 *   records WHICH competition it holds, because `isFetched` alone would tell a
 *   later reader the list is complete when it is one competition's.
 *
 *   The narrowing is implemented in `ApplicationCollectionDataProvider`, not
 *   by an `@ApiFilter`: that provider replaces API Platform's Doctrine one, so
 *   an annotation is never consulted and returns everything.
 */
export const fetchApplications = (query) => {
    const params = query && Object.keys(query).length ? query : null;
    const competition = (params && params.competition) || null;

    return function(dispatch) {
        dispatch(fetchRequest());
        return axios(apiRequestOptions(apiPath.APPLICATIONS.LIST, params))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSuccess(response.data, competition)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => {
    return {
        type: APPLICATIONS_REQUEST,
    }
};

const fetchFailure = (error) => {
    return {
        type: APPLICATIONS_FAILURE,
        error,
    }
};

const fetchSuccess = (data, competition) => {
    return {
        type: APPLICATIONS_SUCCESS,
        data,
        // null for the unfiltered read — «this is every application».
        competition: competition || null,
    }
};